export default __webpack_public_path__ + "images/wallpaper.c6a95969beccff15dfac084b1ea2e285.png";